import type { Control } from "react-hook-form";
import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	CommoditiesCreateFormInput,
	CommoditiesCreateFormOutput,
} from "web_myplann/Portfolio/Forms/CommoditiesForm/commoditiesFormSchema";
import { InvestmentAdditionalFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentAdditionalFields";
import { InvestmentBasicFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentBasicFields";
import { InvestmentToolsSection } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentToolsSection";
import { InvestmentValuesSection } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentValuesSection";

type CommoditiesCreateFormFieldsProps = {
	control: Control<
		CommoditiesCreateFormInput,
		unknown,
		CommoditiesCreateFormOutput
	>;
};

export const CommoditiesCreateFormFields = ({
	control,
}: CommoditiesCreateFormFieldsProps) => {
	const { t } = useResource();

	return (
		<>
			<InvestmentBasicFields
				control={control}
				domain={ClientPortfolioDomainEnum.Commodities}
				namePlaceholder={t(
					Resources.Portfolio.AddCommodities.Placeholders.name,
				)}
			/>
			<InvestmentValuesSection control={control} />
			<InvestmentToolsSection control={control} />
			<InvestmentAdditionalFields control={control} />
		</>
	);
};
